import {FC, SVGProps} from "react";

export const WindowsManifestIcon:FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14 2L20 8V20C20 20.5304 19.7891 21.039 19.4141 21.4141C19.039 21.7891 18.5304 22 18 22H6C5.46957 22 4.96101 21.7891 4.58594 21.4141C4.21086 21.039 4 20.5304 4 20V4C4 3.46957 4.21086 2.96101 4.58594 2.58594C4.96101 2.21086 5.46957 2 6 2H14ZM7 15.7373V20H11.7373V15.7373H7ZM12.2627 15.7373V20H17V15.7373H12.2627ZM7 11V15.2627H11.7373V11H7ZM12.2627 11V15.2627H17V11H12.2627ZM13 9H18.5L13 3.5V9Z" fill="#E9E9E9"/>
  </svg>
)



